import React from "react";
import styles from "./VideoCard.module.css";

export default function VideoCard({ item, liked, onPlay, onToggleLike, progressPct }){
  return (
    <div className={styles.card}>
      <div className={styles.thumb}>
        <video className={styles.media} src={item.url} muted preload="metadata" />
        <div className={styles.progress}><div className={styles.fill} style={{width:`${progressPct||0}%`}}/></div>
      </div>
      <div className={styles.meta}>
        <h4 className={styles.title} title={item.title}>{item.title}</h4>
        {item.duration && <p className={styles.subtitle}>~ {Math.round(item.duration/60)} min</p>}
      </div>
      <div className={styles.actions}>
        <button className={styles.btn} onClick={()=>onPlay(item)}>▶ Play</button>
        <div className={`${styles.like} ${liked? styles.liked: ''}`} onClick={()=>onToggleLike(item.id)} title={liked? 'Unlike' : 'Like'}>
          <span className={styles.heart} aria-hidden />
          <span>{liked? 'Liked' : 'Like'}</span>
        </div>
      </div>
    </div>
  );
}